// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 476) return "js/476.js";
	// return url for filenames based on template
	return "" + "/js/vendor" + ".js";
};